import types from './types'
import { nauta } from '../../api'

const updateAct = (buttons) => ({ type: types.update, buttons })

const get = () => (dispatch) => {
  
  return nauta.get('').then((result) => {
    if (result.status === 200) {
      dispatch(updateAct({ buttons: result.data }))
    }
    return ({ status: result.status, data: result.data })
  }).catch((error) => {
    console.log(error)
  })
}

export {
  updateAct,
  get,
}